import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa6";
import gs from "../../assets/images/gs.jpg";
import vp from "../../assets/images/vp.jpg";
import member from "../../assets/images/member.jpg";
import { Link } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";

const MoshjidCommittee = () => {
  const members = [
    {
      name: "Md. Mizanur Rahman",
      role: "Present Motowali",
      image: "https://i.ibb.co.com/NdFtgrDm/motowalli.jpg",
    },
    { name: "Md. Aminur Rahman", role: "Motowali Panel 1", image: "#" },
    {
      name: "Azizur Rahman",
      role: "Motowali Panel 2",
      image:
        "https://i.ibb.co.com/fzcYPKtH/Whats-App-Image-2025-02-16-at-14-31-51-f1ca74ef.jpg",
    },
    {
      name: "Update",
      role: "Motowali Panel 3",
      image: "https://i.ibb.co.com/842x5hB5/panel3.jpg",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-stone-50 via-white to-green-50/20 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto w-full">
        {/* Header Section */}
        <div className="text-center mb-10">
          <Fade direction="up" triggerOnce>
            <span className="text-sm font-semibold tracking-widest uppercase text-emerald-800 block mb-2">
              Leadership & Governance
            </span>
            <h2 className="text-4xl font-extrabold text-green-950 tracking-tight mb-3">
              Mosque Committee
            </h2>
            <p className="text-gray-500 max-w-md mx-auto mb-6 text-sm sm:text-base">
              Dedicated members serving our community to manage operations and
              growth transparently.
            </p>
          </Fade>

          <Slide direction="up" triggerOnce>
            <div>
              <Link
                to="/membership"
                className="inline-block px-6 py-2.5 bg-green-950 text-white font-medium rounded-full hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-0.5 shadow-md hover:shadow-lg text-sm"
              >
                Become a Member
              </Link>
            </div>
          </Slide>
        </div>

        {/* 3-Column Profile Cards Layout Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12 justify-center">
          {members.map((person, index) => (
            <Slide key={index} direction="up" delay={index * 100} triggerOnce>
              <div className="group relative bg-white border border-stone-100 rounded-2xl p-6 flex flex-col items-center text-center shadow-sm transform transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-xl">
                {/* Subtle top indicator border bar on hover */}
                <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-emerald-700 to-green-900 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Avatar with dynamic outline wrapper */}
                <div className="relative mb-4">
                  <div className="absolute inset-0 bg-emerald-800 rounded-full blur opacity-10 group-hover:opacity-20 transition-opacity" />
                  <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-white shadow-md relative">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </div>

                {/* Identity Segment */}
                <h3 className="text-lg font-bold text-gray-900 tracking-tight group-hover:text-emerald-900 transition-colors">
                  {person.name}
                </h3>
                <p className="text-sm font-medium text-emerald-800 bg-emerald-50/60 px-3 py-0.5 rounded-full mt-1">
                  {person.role}
                </p>

                {/* Clean minimalist social connectivity link row */}
                <div className="flex space-x-4 mt-6 pt-4 border-t border-stone-100 w-full justify-center text-stone-400">
                  <a
                    href="#"
                    className="hover:text-emerald-800 transition-colors duration-200"
                  >
                    <FaFacebook size={18} />
                  </a>
                  <a
                    href="#"
                    className="hover:text-emerald-800 transition-colors duration-200"
                  >
                    <FaTwitter size={18} />
                  </a>
                  <a
                    href="#"
                    className="hover:text-emerald-800 transition-colors duration-200"
                  >
                    <FaLinkedin size={18} />
                  </a>
                </div>
              </div>
            </Slide>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoshjidCommittee;
